export const getSearchParam = (
  query: string | string[] | undefined | null
): string | undefined => {
  if (typeof query === 'string' && query !== '') {
    return query;
  }

  return undefined;
};
